import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

type HiringMessageTemplateDictionary = { [templateId: number]: TextMessageTemplate };
type EmployeeMessageTemplateDictionary = { [templateId: number]: EmployeeMessageTemplate };

export type MessageTemplateState = {
  hiringMessageTemplatesById: HiringMessageTemplateDictionary;
  hiringMessageTemplatesStateByJobId: StateDictionary;
  employeeMessageTemplatesById: EmployeeMessageTemplateDictionary;
  employeeMessageTemplatesStateByOrgId: StateDictionary;
};

type State = { messageTemplates: MessageTemplateState };

const hiringMessageTemplatesByIdSelector = (state: State) =>
  state.messageTemplates.hiringMessageTemplatesById;
export const hiringMessageTemplatesForJobIdSelector = createSelector(
  [hiringMessageTemplatesByIdSelector, (_state: State, jobId: number) => jobId],
  (hiringMessageTemplatesById, jobId) =>
    Object.values(hiringMessageTemplatesById).filter(
      (template) => template.isActive && template.jobId === jobId,
    ),
);

const hiringMessageTemplatesStateByJobIdSelector = (state: State) =>
  state.messageTemplates.hiringMessageTemplatesStateByJobId;
export const hiringMessageTemplatesStateForJobIdSelector = createSelector(
  [hiringMessageTemplatesStateByJobIdSelector, (_state: State, jobId: number) => jobId],
  (hiringMessageTemplatesStateByJobId, jobId) => hiringMessageTemplatesStateByJobId[jobId],
);

const employeeMessageTemplatesByIdSelector = (state: State) =>
  state.messageTemplates.employeeMessageTemplatesById;
export const employeeMessageTemplatesForOrgIdSelector = createSelector(
  [employeeMessageTemplatesByIdSelector, (_state: State, orgId: number) => orgId],
  (employeeMessageTemplatesById, orgId) =>
    Object.values(employeeMessageTemplatesById).filter(
      (template) => template.isActive && template.orgId === orgId,
    ),
);

const employeeMessageTemplatesStateByOrgIdSelector = (state: State) =>
  state.messageTemplates.employeeMessageTemplatesStateByOrgId;
export const employeeMessageTemplatesStateForOrgIdSelector = createSelector(
  [employeeMessageTemplatesStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (employeeMessageTemplatesStateByOrgId, orgId) => employeeMessageTemplatesStateByOrgId[orgId],
);
